import React, { useState } from 'react';
import { Link } from "react-router-dom";
import {
  Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination,
} from '@mui/material';
import { ExpandMore, ExpandLess, Search,  History, MoreVert, Add, Edit } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HistoriqueModal from './HistoriqueModal';




export default function TarifsTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);
  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };
  const handleDelete = () => {
    try {
      // 👉 Your actual delete logic (e.g., API call, state update)
      // e.g., await deleteTrajet(selectedTrajet)
  
      // If successful
      handleSnack('Trajet(s) supprimé(s) avec succès', 'success');
    } catch (error) {
      // If there's an error
      handleSnack("Erreur lors de la suppression du trajet", 'error');
    }
  };
  


  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const rows = [
    { id: 1, region: "Île-de-France", zone: "Paris", places: 50, tarif: 15, statut: "Actif" },
    { id: 2, region: "Provence-Alpes-Côte d'Azur", zone: "Nice", places: 40, tarif: 20, statut: "Inactif" },
    { id: 3, region: "Auvergne-Rhône-Alpes", zone: "Lyon", places: 30, tarif: 18, statut: "Actif" },
    { id: 4, region: "Occitanie", zone: "Toulouse", places: 45, tarif: 17, statut: "Inactif" },
  ];
  

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1); // reset to first page when rows per page change
  };

  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(rows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <AttachMoneyIcon />
            <Typography variant="h6">TARIFS</Typography>
          </Box>
          <Button
          component={Link}
          to="/Add-tarif"
          variant="outlined" sx={{
            color: 'red',
            borderColor: 'red',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
          }} startIcon={<Add />}>Ajouter</Button>
        </Box>

        {/* Search Section */}
        <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Région</InputLabel>
                <Select label="Région">
                  <MenuItem value="Région 1">Région 1</MenuItem>
                  <MenuItem value="Région 2">Région 2</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Statut</InputLabel>
                <Select label="Statut">
                  <MenuItem value="En cours">En cours</MenuItem>
                  <MenuItem value="Terminé">Terminé</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Reset</Button>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Search</Button>
            </Box>
          </Paper>
        </Collapse>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
        <Table>
            <TableHead>
            <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Région</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Zone</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Places</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Tarif</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
                    {paginatedRows.map((row, index) => (
                    <TableRow key={row.id} hover>
                    <TableCell>{row.id}</TableCell>   
                    <TableCell>{row.region}</TableCell>
                    <TableCell>{row.zone}</TableCell>
                    <TableCell>{row.places}</TableCell>
                    <TableCell>{row.tarif} €</TableCell>
                    <TableCell>
                    <Box
                        sx={{
                        backgroundColor: row.statut === 'Actif' ? '#4caf50' : '#dc3545',
                        color: 'white',
                        borderRadius: '4px',
                        px: 1,
                        py: 0.5,
                        display: 'inline-block',
                        fontSize: '0.8rem',
                        textAlign: 'center',
                        minWidth: '60px',
                        }}
                    >
                        {row.statut}
                    </Box>
                    </TableCell>
                    <TableCell>
                    <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                        <MoreVert />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={menuRowId === row.id && openMenu}
                        onClose={handleMenuClose}
                        PaperProps={{
                        sx: {
                            minWidth: '200px',
                            '& .MuiMenuItem-root': {
                            color: 'black',
                            '& .MuiListItemIcon-root': { color: 'black' },
                            '&:hover': {
                                backgroundColor: 'red',
                                color: 'white',
                                '& .MuiListItemIcon-root': { color: 'white' },
                            },
                            },
                        },
                        }}
                    >
                        <MenuItem component={Link} to="/edit-tarif">
                        <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                        <ListItemText>Modifier</ListItemText>
                        </MenuItem>
                        <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                        <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                        <ListItemText>Historique</ListItemText>
                        </MenuItem>
                    </Menu>
                    </TableCell>
                </TableRow>
                 ))}
            </TableBody>
        </Table>
        </TableContainer>


        {/* Pagination + entries info */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>

      </Box>
      <Snackbar open={snack.open} autoHideDuration={3000} onClose={handleCloseSnack} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
  <MuiAlert onClose={handleCloseSnack} severity={snack.type} elevation={6} variant="filled" sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}>
    {snack.message}
  </MuiAlert>
</Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />


    </Box>

    
  );
}
